import { SVGProps, Ref, forwardRef } from 'react';

export const MetroLineSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <rect x={9} y={4} width={6} height={16} rx={3} fill="currentColor" />
    </svg>
));
MetroLineSize24Glyph.displayName = 'MetroLineSize24Glyph';
